// Theme: carbon
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'carbon',
  name: 'CARBON',
  tagline: 'CARBON',
  description: 'Fibra de carbono. Grafite metalico de alta tecnologia.',
  category: 'system-core',
  tier: 'rare',
  basePrice: 900,
  swatches: ['#0A0A0C', '#94A3B8', '#1A1A1F', '#E2E8F0'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '2px',
      '--radius': '4px',
      '--shadow-card': '0 8px 20px rgba(148, 163, 184, 0.08)',
      '--shadow-card-active': '0 8px 20px rgba(148, 163, 184, 0.08)'
    },
    shellClasses: 'font-sans theme-carbon'
  },
  colorVars: {
    '--accent': '#94A3B8',
    '--accent-foreground': '#0A0A0C',
    '--background': '#0A0A0C',
    '--border': '#3A3A45',
    '--card': '#1A1A1F',
    '--card-border-active': 'rgba(148, 163, 184, 0.08)',
    '--card-completed': '#222229',
    '--card-foreground': '#E2E8F0',
    '--card-glow': 'rgba(148, 163, 184, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0A0C',
    '--foreground': '#E2E8F0',
    '--hold-fill': '#94A3B8',
    '--input': '#1A1A1F',
    '--modal-bg': '#0A0A0C',
    '--modal-border': '#3A3A45',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(148, 163, 184, 0.08)',
    '--muted': '#3A3A45',
    '--muted-foreground': '#B5C1D0',
    '--nav-active': '#94A3B8',
    '--nav-bg': '#0A0A0C',
    '--popover': '#1A1A1F',
    '--popover-foreground': '#E2E8F0',
    '--primary': '#94A3B8',
    '--primary-foreground': '#0A0A0C',
    '--ring': '#94A3B8',
    '--secondary': '#3A3A45',
    '--secondary-foreground': '#E2E8F0',
    '--streak': '#94A3B8',
    '--success': '#22c55e',
    '--success-foreground': '#0A0A0C',
    '--xp': '#94A3B8',
    '--xp-bg': '#1A1A1F'
  },
  resolvedVars: {
    '--accent': '#94A3B8',
    '--accent-foreground': '#0A0A0C',
    '--accent-foreground-hsl': '240 9% 4%',
    '--accent-foreground-oklch': 'from #0A0A0C l c h',
    '--accent-hsl': '215 20% 65%',
    '--accent-oklch': 'from #94A3B8 l c h',
    '--background': '#0A0A0C',
    '--background-hsl': '240 9% 4%',
    '--background-oklch': 'from #0A0A0C l c h',
    '--border': '#3A3A45',
    '--border-hsl': '240 9% 25%',
    '--border-oklch': 'from #3A3A45 l c h',
    '--border-w': '2px',
    '--card': '#1A1A1F',
    '--card-border-active': 'rgba(148, 163, 184, 0.08)',
    '--card-completed': '#222229',
    '--card-completed-hsl': '240 9% 15%',
    '--card-completed-oklch': 'from #222229 l c h',
    '--card-foreground': '#E2E8F0',
    '--card-foreground-hsl': '214 32% 91%',
    '--card-foreground-oklch': 'from #E2E8F0 l c h',
    '--card-glow': 'rgba(148, 163, 184, 0.08)',
    '--card-hsl': '240 9% 11%',
    '--card-oklch': 'from #1A1A1F l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0A0C',
    '--destructive-foreground-hsl': '240 9% 4%',
    '--destructive-foreground-oklch': 'from #0A0A0C l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E2E8F0',
    '--foreground-hsl': '214 32% 91%',
    '--foreground-oklch': 'from #E2E8F0 l c h',
    '--hold-fill': '#94A3B8',
    '--hold-fill-hsl': '215 20% 65%',
    '--hold-fill-oklch': 'from #94A3B8 l c h',
    '--input': '#1A1A1F',
    '--input-hsl': '240 9% 11%',
    '--input-oklch': 'from #1A1A1F l c h',
    '--modal-bg': '#0A0A0C',
    '--modal-bg-hsl': '240 9% 4%',
    '--modal-bg-oklch': 'from #0A0A0C l c h',
    '--modal-border': '#3A3A45',
    '--modal-border-hsl': '240 9% 25%',
    '--modal-border-oklch': 'from #3A3A45 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(148, 163, 184, 0.08)',
    '--muted': '#3A3A45',
    '--muted-foreground': '#B5C1D0',
    '--muted-foreground-hsl': '213 22% 76%',
    '--muted-foreground-oklch': 'from #B5C1D0 l c h',
    '--muted-hsl': '240 9% 25%',
    '--muted-oklch': 'from #3A3A45 l c h',
    '--nav-active': '#94A3B8',
    '--nav-active-hsl': '215 20% 65%',
    '--nav-active-oklch': 'from #94A3B8 l c h',
    '--nav-bg': '#0A0A0C',
    '--nav-bg-hsl': '240 9% 4%',
    '--nav-bg-oklch': 'from #0A0A0C l c h',
    '--popover': '#1A1A1F',
    '--popover-foreground': '#E2E8F0',
    '--popover-foreground-hsl': '214 32% 91%',
    '--popover-foreground-oklch': 'from #E2E8F0 l c h',
    '--popover-hsl': '240 9% 11%',
    '--popover-oklch': 'from #1A1A1F l c h',
    '--primary': '#94A3B8',
    '--primary-foreground': '#0A0A0C',
    '--primary-foreground-hsl': '240 9% 4%',
    '--primary-foreground-oklch': 'from #0A0A0C l c h',
    '--primary-hsl': '215 20% 65%',
    '--primary-oklch': 'from #94A3B8 l c h',
    '--radius': '4px',
    '--ring': '#94A3B8',
    '--ring-hsl': '215 20% 65%',
    '--ring-oklch': 'from #94A3B8 l c h',
    '--secondary': '#3A3A45',
    '--secondary-foreground': '#E2E8F0',
    '--secondary-foreground-hsl': '214 32% 91%',
    '--secondary-foreground-oklch': 'from #E2E8F0 l c h',
    '--secondary-hsl': '240 9% 25%',
    '--secondary-oklch': 'from #3A3A45 l c h',
    '--shadow-card': '0 8px 20px rgba(148, 163, 184, 0.08)',
    '--shadow-card-active': '0 8px 20px rgba(148, 163, 184, 0.08)',
    '--streak': '#94A3B8',
    '--streak-hsl': '215 20% 65%',
    '--streak-oklch': 'from #94A3B8 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0A0A0C',
    '--success-foreground-hsl': '240 9% 4%',
    '--success-foreground-oklch': 'from #0A0A0C l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(215 20% 65% / 0.15)',
    '--xp': '#94A3B8',
    '--xp-bg': '#1A1A1F',
    '--xp-bg-hsl': '240 9% 11%',
    '--xp-bg-oklch': 'from #1A1A1F l c h',
    '--xp-hsl': '215 20% 65%',
    '--xp-oklch': 'from #94A3B8 l c h'
  }
}
